const TableStyle = {
  row: {
    fontSize: '14px',
    lineHeight: '20px',
    color: '#252733',
    fontWeight: '500',
  },
}

export default TableStyle;